<div class="container">
  <div class="row">
    <h1 class="big-title">Our Themepark</h1>
  </div>
  <div class="row description showRow p-3">
    <h2 class="title">About the Park:</h2>
    <span>The Themepark is a Project that was started in the 1.13 Snapshots.</span>
    <span>It is running in vanilla Minecraft without any plugins or Mods. Just data packs and Resource packs.</span>
    <span>The Goal is to have smooth animations for the rides and huge amount of detail.</span>
    <span>On top of that, we want to stay as realistic as possible.</span>
    <span>The park is constantly evolving and we are always using the newest technologies available in Minecraft to reach our goals.</span>
  </div>
  <div class="row showRow my-3">
    <h2 class="title">How the Entrence evolved:</h2>
    <div *ngFor="let image of Entrance" class="col-6 col-md py-2">
      <img class="showImg" src="{{'assets/images/park/' + image.img}}">
    </div>
  </div>
  <div class="row showRow my-3">
    <h2 class="title">A scrapped coaster:</h2>
    <div *ngFor="let image of Coaster" class="col-12 col-md py-2">
      <img class="showImg" src="{{'assets/images/park/' + image.img}}">
    </div>
  </div>
  <div class="row showRow my-3">
    <h2 class="title">The Logflume:</h2>
    <div *ngFor="let image of Water" class="col-6 col-md-4 py-2">
      <img class="showImg" src="{{'assets/images/park/' + image.img}}">
    </div>
  </div>
  <div class="row showRow my-3">
    <h2 class="title">Here are some more Rides:</h2>
    <div *ngFor="let image of Rides" class="col-6 col-md py-2">
      <img class="showImg" src="{{'assets/images/park/' + image.img}}">
    </div>
  </div>
  <div class="row showRow my-3">
    <h2 class="title">DETAILS!</h2>
    <div *ngFor="let image of Details" class="col-6 col-md py-2">
      <img class="showImg" src="{{'assets/images/park/' + image.img}}">
    </div>
  </div>
  <div class="row showRow my-3">
    <h2 class="title">A few nighttime pictures:</h2>
    <div *ngFor="let image of Night" class="col-6 col-md-4 py-2">
      <img class="showImg" src="{{'assets/images/park/' + image.img}}">
    </div>
  </div>
  <div class="row showRow my-3">
    <h2 class="title">All of it powered by just Datapacks:</h2>
    <div *ngFor="let image of Datapack" class="col-12 col-md py-2">
      <img class="showImg" src="{{'assets/images/park/' + image.img}}">
    </div>
  </div>
  <div class="row">
    <app-backbutton class="mb-3"></app-backbutton>
  </div>
</div>

